define('TescoMobile_Checkout/js/view/summary/grand-total',['Magento_Tax/js/view/checkout/summary/grand-total', 'Magento_Checkout/js/model/quote'], function (Component, quote) {
  'use strict';

  return Component.extend({
    isUpgrade: function () {
      var _quote$getData;
      return ((_quote$getData = quote.getData('extension_attributes')) === null || _quote$getData === void 0 ? void 0 : _quote$getData.tm_quote_type) === 'UPGRADE';
    }
  });
});

